import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ShoppingListsItem extends PureComponent {
  static propTypes = {
    shoppingList: PropTypes.shape({
      listId: PropTypes.string.isRequired,
      listName: PropTypes.string.isRequired,
      containsSku: PropTypes.bool,
    }).isRequired,
    onAddToShoppingList: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.addToShoppingList = this.addToShoppingList.bind(this);
  }

  addToShoppingList() {
    this.props.onAddToShoppingList(this.props.shoppingList.listId);
  }

  render() {
    const { shoppingList } = this.props;
    return (
      shoppingList.containsSku ?
        (
          <li className="sl-modal__content--listItem sl-modal__content--listItemContainsSku">
            <div className="sl-modal__content--listItemStaticContent">
              <span className="sl-modal__content--listLabel">{shoppingList.listName}</span>
              <span className="sl-modal__content--listIndicator">On the list</span>
            </div>
          </li>
        ) : (
          <li className="sl-modal__content--listItem">
            <button
              className="sl-modal__content--listItemAddButton"
              onClick={this.addToShoppingList}
            >
              <span className="sl-modal__content--listLabel">{shoppingList.listName}</span>
            </button>
          </li>
        )
    );
  }
}
